import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
import { AccordionContext } from './accordion.context';
import { AccordionItemContext } from './accordionItem.context';
import { Chevron } from './icon';
export const AccordionToggle = ({ children, ...rest }) => {
    const { disabled, darkTheme } = useContext(AccordionContext);
    const { toggleOpen, open, itemDisabled } = useContext(AccordionItemContext);
    const keyDown = (event) => {
        if (event.key && (event.key == 'Enter' || event.key == ' ')) {
            toggleOpen();
        }
    };
    return (_jsxs(AccordionToggleStyled, { ...rest, tabIndex: 0, role: "button", "aria-expanded": open ? 'true' : 'false', onClick: disabled || itemDisabled ? null : toggleOpen, onKeyDown: (e) => keyDown(e), open: open, disabled: disabled, darkTheme: darkTheme, "data-ga": "accordion-title", children: [_jsx(TitleStyled, { children: children }), !disabled && !itemDisabled && (_jsx(CloseButtonStyled, { children: _jsx(Chevron, {}) }))] }));
};
const TitleStyled = styled.span `
  user-select: none;
`;
const CloseButtonStyled = styled.span `
  height: ${({ theme }) => pxToRems(theme.FontTextText400LineHeight)};
  width: ${({ theme }) => pxToRems(theme.FontTextText400LineHeight)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 ${({ theme }) => pxToRems(theme.FontTextText400LineHeight)};

  > svg {
    fill: currentColor;
    width: 16px;
  }
`;
export const AccordionToggleStyled = styled.div `
  font-size: ${({ theme, fontSize }) => pxToRems(fontSize) || pxToRems(theme.FontTextText300MidFontSize)};

  font-weight: ${({ theme, fontWeight }) => fontWeight || theme.FontTextText400MidFontWeight};

  line-height: ${({ theme }) => pxToRems(theme.FontTextText300MidLineHeight)};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  width: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  padding: 12px 0;

  &:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 4px ${({ theme }) => theme.ColorGrey100};
  }

  ${CloseButtonStyled} {
    > svg {
      transform: rotate(${({ open }) => (open ? '180' : '0')}deg);
    }
  }
`;
//# sourceMappingURL=accordionToggle.js.map